import { all, call, put, takeLatest } from 'redux-saga/effects';

import { DAS_REMOVE_ACCOMMODATION_FROM_BASKET_FAILED } from '../../constants/errors';
import { basketTypes } from '../../store/basket';
import { createError } from '../../store/errors';
import { messageOperations } from '../../store/messages';
import { reloadBasket } from './helpers';
import { removeAccommodationFromBasket } from '../../api/basket';

const { REMOVE_ACCOMMODATION } = basketTypes;
const { sendMessage } = messageOperations;

export const performRemoveAccommodationFromBasket = function* performRemoveAccommodationFromBasket({
  payload,
}) {
  try {
    const removeFromBasketResponse = yield call(
      removeAccommodationFromBasket,
      payload.bookingRef,
      payload.accoId,
    );

    if (removeFromBasketResponse.errors) {
      // Handle web service errors.
      yield all(
        removeFromBasketResponse.errors.map(error => put(createError(error))),
      );
      return;
    }

    const basketResponse = yield call(reloadBasket, payload.bookingRef);
    if (basketResponse.errors) {
      return;
    }

    const { qty, roomName } = payload;

    yield put(
      sendMessage({
        type: 'success',
        displayType: 'toast',
        message: `${qty} x ${roomName} ${
          qty === 1 ? 'was' : 'were'
        } removed from your basket.`,
      }),
    );
  } catch (error) {
    yield put(
      createError({
        code: DAS_REMOVE_ACCOMMODATION_FROM_BASKET_FAILED,
      }),
    );
  }
};

export default takeLatest(
  REMOVE_ACCOMMODATION,
  performRemoveAccommodationFromBasket,
);
